var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSilverMedal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 30,
    viewBox: "0 0 28 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4742 22.9941C22.6577 20.8671 25.1355 14.9408 23.0086 9.75735C20.8816 4.57386 14.9553 2.09605 9.77183 4.22301C4.58834 6.34998 2.11053 12.2763 4.2375 17.4598C6.36446 22.6432 12.2908 25.1211 17.4742 22.9941Z",
    fill: "url(#paint0_linear_6808_8830)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.83124 28.9577L7.77827 27.1295C7.66646 27.0179 7.52222 26.9444 7.36618 26.9197L4.82619 26.7099C4.78274 26.7067 4.74072 26.6929 4.70373 26.6699C4.66673 26.6469 4.63587 26.6152 4.61378 26.5777C4.59169 26.5401 4.57902 26.4978 4.57687 26.4542C4.57471 26.4107 4.58314 26.3673 4.60141 26.3278L8.22782 18.0859L13.8997 20.5885L10.2658 28.8303C10.253 28.8735 10.2295 28.9127 10.1976 28.9445C10.1657 28.9762 10.1264 28.9995 10.0832 29.0122C10.04 29.0248 9.99427 29.0265 9.95027 29.017C9.90626 29.0074 9.86534 28.9871 9.83124 28.9577Z",
    fill: "url(#paint1_linear_6808_8830)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3987 28.959L19.4517 27.1308C19.5674 27.0301 19.7113 26.9673 19.8638 26.9509L22.4038 26.7412C22.4472 26.7379 22.4893 26.7242 22.5262 26.7012C22.5632 26.6781 22.5941 26.6465 22.6162 26.6089C22.6383 26.5714 22.6509 26.529 22.6531 26.4855C22.6553 26.442 22.6468 26.3986 22.6286 26.359L19.0021 18.1172L13.3303 20.6197L16.9567 28.869C16.9733 28.9106 16.9999 28.9474 17.0343 28.9761C17.0686 29.0048 17.1096 29.0245 17.1534 29.0334C17.1973 29.0423 17.2427 29.0402 17.2855 29.0272C17.3283 29.0142 17.3672 28.9907 17.3987 28.959Z",
    fill: "url(#paint2_linear_6808_8830)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.424 20.4232C24.184 16.6633 24.184 10.5672 20.424 6.80723C16.664 3.04728 10.568 3.04728 6.808 6.80723C3.04805 10.5672 3.04805 16.6633 6.808 20.4232C10.568 24.1832 16.664 24.1832 20.424 20.4232Z",
    fill: "url(#paint3_linear_6808_8830)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5803 18.5795C21.322 15.8378 21.322 11.3927 18.5803 8.65096C15.8386 5.90926 11.3935 5.90926 8.65178 8.65096C5.91008 11.3927 5.91008 15.8378 8.65178 18.5795C11.3935 21.3212 15.8386 21.3212 18.5803 18.5795Z",
    fill: "url(#paint4_linear_6808_8830)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.94656 13.9574C6.94447 12.5905 7.34226 11.253 8.09093 10.1094C8.8396 8.96586 9.90644 8.06629 11.16 7.52154C12.4136 6.97678 13.7991 6.81063 15.146 7.04356C16.4928 7.27649 17.7421 7.89831 18.7399 8.83243C18.0946 8.15953 17.3214 7.6222 16.4658 7.25193C15.6101 6.88167 14.6892 6.68592 13.7569 6.67616C12.8247 6.66641 11.8998 6.84283 11.0366 7.19511C10.1734 7.54738 9.38917 8.06841 8.72992 8.72766C8.07067 9.38692 7.54964 10.1711 7.19737 11.0343C6.84509 11.8976 6.66867 12.8224 6.67842 13.7547C6.68818 14.6869 6.88393 15.6079 7.25419 16.4635C7.62445 17.3192 8.16178 18.0923 8.83469 18.7376C7.61984 17.4426 6.94458 15.733 6.94656 13.9574Z",
    fill: "white"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.615 6.59375H13.4352C14.7373 6.62647 16.0012 7.04024 17.0706 7.78388C18.14 8.52751 18.9679 9.56836 19.4519 10.7776C19.9359 11.9869 20.0546 13.3116 19.7936 14.5877C19.5325 15.8638 18.903 17.0353 17.983 17.9574C17.0629 18.8794 15.8928 19.5115 14.6173 19.7753C13.3417 20.0392 12.0168 19.9233 10.8065 19.442C9.59615 18.9607 8.55348 18.1351 7.80751 17.0673C7.06153 15.9996 6.64499 14.7365 6.60941 13.4345C6.6057 13.4944 6.6057 13.5544 6.60941 13.6143C6.60941 15.0028 7.02116 16.3602 7.79259 17.5147C8.56402 18.6692 9.66048 19.5691 10.9433 20.1004C12.2262 20.6318 13.6378 20.7708 14.9996 20.5C16.3615 20.2291 17.6124 19.5604 18.5942 18.5786C19.5761 17.5967 20.2447 16.3458 20.5156 14.9839C20.7865 13.6221 20.6475 12.2105 20.1161 10.9277C19.5847 9.64482 18.6849 8.54836 17.5304 7.77693C16.3758 7.0055 15.0185 6.59375 13.63 6.59375H13.615Z",
    fill: "#9B9B9B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9906 12.9933C10.9785 12.6309 11.0208 12.2957 11.1174 11.9878C11.214 11.6737 11.359 11.402 11.5522 11.1725C11.7455 10.937 11.987 10.7558 12.2769 10.629C12.5728 10.4961 12.911 10.4297 13.2914 10.4297C13.5813 10.4297 13.8561 10.475 14.1158 10.5656C14.3815 10.6562 14.614 10.786 14.8133 10.9551C15.0126 11.1242 15.1696 11.3325 15.2843 11.5801C15.4051 11.8277 15.4655 12.1055 15.4655 12.4135C15.4655 12.7336 15.4142 13.0083 15.3115 13.2378C15.2088 13.4673 15.073 13.6726 14.9039 13.8538C14.7348 14.0289 14.5415 14.189 14.3241 14.3339C14.1128 14.4789 13.8984 14.6238 13.681 14.7687C13.4636 14.9076 13.2522 15.0586 13.0469 15.2217C12.8415 15.3847 12.6604 15.5749 12.5034 15.7923H15.5017V16.8975H10.8456C10.8456 16.5291 10.897 16.209 10.9996 15.9373C11.1083 15.6655 11.2533 15.424 11.4344 15.2126C11.6156 14.9952 11.827 14.7959 12.0685 14.6147C12.3161 14.4336 12.5758 14.2494 12.8476 14.0622C12.9865 13.9655 13.1344 13.8689 13.2914 13.7723C13.4485 13.6696 13.5904 13.5579 13.7172 13.4371C13.8501 13.3163 13.9588 13.1805 14.0433 13.0295C14.1339 12.8785 14.1792 12.7064 14.1792 12.5131C14.1792 12.2052 14.0886 11.9666 13.9074 11.7975C13.7323 11.6224 13.5058 11.5348 13.228 11.5348C13.0408 11.5348 12.8808 11.5801 12.7479 11.6707C12.6211 11.7553 12.5185 11.87 12.4399 12.0149C12.3614 12.1538 12.3041 12.3108 12.2678 12.486C12.2376 12.6551 12.2225 12.8242 12.2225 12.9933H10.9906Z",
    fill: "#565656"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6808_8830",
    x1: 3.4732,
    y1: 13.6123,
    x2: 23.7631,
    y2: 13.6123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6808_8830",
    x1: 7.88316,
    y1: 26.2903,
    x2: 9.57649,
    y2: 22.8287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D60909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A00505"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6808_8830",
    x1: 19.0996,
    y1: 26.2466,
    x2: 17.5561,
    y2: 22.4554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D60909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A00505"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6808_8830",
    x1: 3.98721,
    y1: 13.6175,
    x2: 23.2432,
    y2: 13.6175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6808_8830",
    x1: 17.6912,
    y1: 17.6935,
    x2: 9.1122,
    y2: 9.10701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5D5D5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilverMedal);
export default __webpack_public_path__ + "static/media/silverMedal.e6e324073bc8abdf6d5728fb57eafd94.svg";
export { ForwardRef as ReactComponent };